import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './css/AdminPanel.css';
import { hasAdminAccess } from '../../Utils/RestUtils';
import {
  MAIN_PAGE,
  SLASH_DELIMITER,
} from '../../Utils/Constants/GlobalConstants';
import {
  ADMIN_PANEL,
  PROMO_SECTION,
  OPERATORS_SECTION,
  ORDERS_SECTION,
  USERS_SECTION,
  SYSTEM_SECTION,
  PROMO_TITLE,
  OPERATORS_TITLE,
  ORDERS_TITLE,
  USERS_TITLE,
  SYSTEM_TITLE,
  CREATE_ORDER,
} from '../../Utils/Constants/AdminConstants';
import Promo from './Promo';
import Operators from './Operators';
import Orders from './Orders';
import Users from './Users';
import SystemSettings from './SystemSettings';

const sections = [
  { id: ORDERS_SECTION, title: ORDERS_TITLE },
  { id: PROMO_SECTION, title: PROMO_TITLE },
  { id: OPERATORS_SECTION, title: OPERATORS_TITLE },
  { id: USERS_SECTION, title: USERS_TITLE },
  { id: SYSTEM_SECTION, title: SYSTEM_TITLE },
];

function AdminPanel() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedSection, setSelectedSection] = useState(ORDERS_SECTION);
  const [isCreateOrderVisible, setIsCreateOrderVisible] = useState(false);

  const closeCreateOrder = useCallback(() => {
    setIsCreateOrderVisible(false);
  }, []);

  const checkAccess = () => {
    const token = window.localStorage.getItem('accessToken');
    hasAdminAccess(token)
      .then((response) => {
        setIsAdmin(response.data === 'SUCCESS');
      })
      .catch(() => {
        setIsAdmin(false);
      });
  };

  useEffect(() => {
    checkAccess();
  }, []);

  const getMenuItemClass = (id) =>
    `ap_menu_item bb_text_16 ${
      selectedSection === id ? 'ap_menu_selected' : ''
    }`;

  const renderMenu = () =>
    sections.map((section) => (
      <button
        key={`ap-menu-${section.id}`}
        type="button"
        className={getMenuItemClass(section.id)}
        onClick={() => setSelectedSection(section.id)}
      >
        {section.title}
      </button>
    ));

  const selected = sections.find((section) => section.id === selectedSection);

  return (
    <div className="containerW ap_container">
      {isAdmin && (
        <div>
          <div className="ap_breadcrumbs">
            <Link className="gm_text_14" to="/">
              {MAIN_PAGE}
            </Link>
            <div className="hd_breadcrumb_delimiter">{SLASH_DELIMITER}</div>
            <div className="gm_text_14">{ADMIN_PANEL}</div>
          </div>
          <div className="ap_menu">{renderMenu()}</div>
          <div className="ap_content_w">
            <div className="ap_title_line mb_20">
              <div className="bm_text_32">{selected.title}</div>
              {selectedSection === ORDERS_SECTION && (
                <button
                  type="button"
                  className="ap_btn btn__yellow dbm_text_16 ap_board_create"
                  onClick={() => setIsCreateOrderVisible(true)}
                >
                  {CREATE_ORDER}
                </button>
              )}
            </div>

            {selectedSection === PROMO_SECTION && <Promo />}

            {selectedSection === OPERATORS_SECTION && <Operators />}

            {selectedSection === ORDERS_SECTION && (
              <Orders
                isCreateModalVisible={isCreateOrderVisible}
                closeCreateModal={closeCreateOrder}
              />
            )}

            {selectedSection === USERS_SECTION && <Users />}

            {selectedSection === SYSTEM_SECTION && <SystemSettings />}
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPanel;
